import { render } from "./PlantListItem.vue?vue&type=template&id=1b185e17&scoped=true"
import script from "./PlantListItem.vue?vue&type=script&lang=js"
export * from "./PlantListItem.vue?vue&type=script&lang=js"

import "./PlantListItem.vue?vue&type=style&index=0&id=1b185e17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b185e17"]])

export default __exports__